<div class="incentive-modal-header">
  <h4 class="modal-title">{{ props.title}}</h4>
  <p *ngIf="props.subTitle" class="modal-subtitle">{{props.subTitle}}</p>
</div>
<div *ngIf="props.radioProps" class="incentive-modal-body">
  <app-radio
    position="vertical"
    [props]="props.radioProps"
    [(ngModel)]="report"
  ></app-radio>
</div>
<div class="modal-footer">
  <button type="button" #loaded class="btn-modal-primary incentive-button" (click)="onClickButton()" [disabled]="!report || disabled">
    {{props.buttonText}}
  </button>
</div>
